import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import type { UserState } from '../../interfaces/user.interface';
import Posts, { type UserPostListItem } from './UserPosts.component';
import '../../styles/post.scss';
import '../../styles/utilities.scss';

type UserPostsProps = {
  userPosts: UserPostListItem[];
};

export default function UserPosts(props: UserPostsProps) {
  const { userPosts } = props;
  const { user } = useSelector((state: UserState) => state.userStore);
  const params = useParams();
  const { username } = params;
  return (
    <div className="USER__POSTS__COL">
      <div className="Post__Wrapper">
        <p>User&#39;s Posts belonging to user with id of {username}</p>
        {!user ? (
          <div className="LoadingSpinner" role="status" aria-label="Loading" />
        ) : (
          <Posts posts={userPosts} />
        )}
      </div>
    </div>
  );
}
